/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Save_TitleInputs */

const en_cap_save_title = /** @type {(inputs: Cap_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The work that repeats, prepared before you get to it.`)
};

const lv_cap_save_title = /** @type {(inputs: Cap_Save_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darbs, kas atkārtojas, sagatavots, pirms pie tā ķeraties.`)
};

/**
* | output |
* | --- |
* | "The work that repeats, prepared before you get to it." |
*
* @param {Cap_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_save_title = /** @type {((inputs?: Cap_Save_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Save_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_save_title(inputs)
	return en_cap_save_title(inputs)
});